export default __webpack_public_path__ + "static/media/permeable-blog-17.8386d282.jpg";